@use '@/scss/underscore' as _;

.form {
  @include _.flex-column;

  > * {
    width: 100%;
  }

  .inputField,
  .terms {
    margin-bottom: _.unit(4);
  }

  .formErrors {
    margin-top: _.unit(-2);
    margin-bottom: _.unit(4);
  }
}
